import { indexTopics } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-extrabold text-foreground-950 font-heading mb-3">
            专题合集
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            按主题分类浏览，快速找到你最感兴趣的吃瓜内容
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {indexTopics.map((item, i) => (
            <a
              key={i}
              href="#index"
              onClick={(e) => e.preventDefault()}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 hover:border-primary-200 hover:bg-primary-50/50 transition-all group cursor-pointer"
            >
              <div className="w-10 h-10 rounded-xl bg-accent-100 flex items-center justify-center mb-3 group-hover:bg-accent-200 transition-colors">
                <i className={`${item.icon} text-lg text-accent-600`}></i>
              </div>
              <h3 className="text-sm font-bold text-foreground-900 mb-1 font-heading whitespace-nowrap">
                {item.title}
              </h3>
              <span className="text-xs text-foreground-400">{item.count} 篇内容</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}